export default __webpack_public_path__ + "static/media/math.7f6d32ca.jpg";